import { PermissionModel } from '@/types';
import BaseService from '@/services/api/BaseService';

class PermissionService extends BaseService<PermissionModel> {}

export default new PermissionService('permissions');
